var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-auto mx-auto",attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"text-subtitle-1 text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('v-progress-circular',{staticClass:"my-5",attrs:{"size":70,"width":7,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }